import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToolsService } from '../../tools/tools.service';
import * as moment from 'moment';
import { SalemethodService } from '../salemethod/salemethod.service';
import { PanierService } from '../../manage/panier/panier.service';
import { Base2Service } from '../base2.service';
import { BaseclientService } from '../../apiclient/baseclient.service';
import { TranslateService } from '@ngx-translate/core';
import { DeliveryZone } from 'src/app/models/interfaces/address.interface';

@Injectable({
  providedIn: 'root'
})

export class PointofsaleService {

  webshopCurrentMerchant: any = "";
  webshopMetaObject: any = null;

  banners = [
    {
      activity: 1,
      banner: "restaurant"
    },
    {
      activity: 2,
      banner: "foodtruck"
    },
    {
      activity: 3,
      banner: "fleuriste"
    },
    {
      activity: 4,
      banner: "boulangerie"
    },
    {
      activity: 5,
      banner: "commerce"
    },
    {
      activity: 6,
      banner: "boutique"
    },
    {
      activity: 7,
      banner: "bar"
    },
    {
      activity: 8,
      banner: "coiffeur"
    },
    {
      activity: 9,
      banner: "coiffeur"
    }
  ];

  constructor(
    private base2: Base2Service,
    private router: Router,
    private tools: ToolsService,
    private smApi: SalemethodService,
    private panMan: PanierService,
    private baseClient: BaseclientService,
    public translate: TranslateService
  ) {
  }

  // getAll(): Observable<any> {

  //   const params = { id_merchant: this.tools.getStor("id_merchant") };

  //   return from(this.baseClient.getBase("points_of_sale", params))
  //     .pipe(
  //       switchMap(data => {

  //         return this.$_parsePointsOfSale(data, true, params.id_merchant).then(parsedPoints => {

  //           if (parsedPoints.length === 1) {

  //             parsedPoints[0].onlyOnePOS = true;
  //             this.setPoint(parsedPoints[0]);

  //             this.tools.goProductPage(parsedPoints[0]);
  //           }

  //           return parsedPoints;
  //         });

  //       })
  //     )
  // }

  $_getPointOfsaleById(posId: any, filter: boolean = true): Promise<any> {
    console.log("posId : ", posId)

    const params = {
      id_webshop: posId
    };

    return new Promise(resolve => {
      this.baseClient.getBase("point_of_sale", params).then(points => {

        this.$_parsePointsOfSale(points, filter).then(parsedPoints => {

          this.tools.setStor("point_of_sale", parsedPoints[0]);
          resolve(parsedPoints);
        });
      });
    });
  }

  $_parsePointsOfSale(points: any, filter: boolean = true, id_merchant = null): Promise<any> {
    if (points.code === -3)
      this.router.navigate(["/404", this.translate.instant('error404.mechantno')], { skipLocationChange: true });
    const parsedPoints_ = filter && points.list ? points.list.filter((point: any) => point.enable_order === 1 || point.enable_order_intent == 1) : points.list;
    const parsedPoints = filter && points.list ? points.list.filter((point: any) => point.enable_order === 1) : points.list;

    if (!parsedPoints || parsedPoints && parsedPoints.length === 0) {
      this.router.navigate(["/404", this.translate.instant('error404.noPof')], { skipLocationChange: true });
    }

    return this.$_getDefaultBanner(parsedPoints, true, id_merchant);
  }

  checkOpening(point: any, date_order?: any) {
    const currDay = point.timetables.filter((day: any) => day.day === moment().day())[0];
    let openFlag = "close";
    let isOpen = true;
    // If no shedules
    if (point.timetables.length < 1) {
      openFlag = "notSpecified";
    } else {
      // If closing array
      if (point.closings.length > 0) {
        for (let i = 0; i < point.closings.length; i++) {
          let period = point.closings[i];
          if (moment().isBetween(period.close_from, period.close_to, "day", "[]")) {
            if (date_order) {
              isOpen = period.close_from == period.close_to ? true : false;
              break;
            }
          }
        }
      }

      // If opening array  (DEPRECATED)
      // if (point.opening.length > 0) {
      //   let openingFlag = true;
      //   for (let i = 0; i < point.opening.length; i++) {
      //     let period = point.opening[i];
      //     if (!moment().isBetween(period.open_from, period.open_to, "day", "[]")) {
      //       openingFlag = false;
      //       break;
      //     }
      //   }

      //   isOpen = openingFlag;


      // }

      // If shedules for today and if is opening
      if (currDay.timeslots.length > 0 && isOpen) {

        for (let i = 0; i < currDay.timeslots.length; i++) {

          let period = currDay.timeslots[i];
          let start = moment(period.start, "HH:mm:ss");

          let end = moment(period.end, "HH:mm:ss");


          if (start > end) {
            end.add(1, 'days');
          }

          if (moment().isBetween(start, end, "m", "[]")) {

            openFlag = "open";
            break;

          } else if (moment().isBefore(start)) {

            openFlag = moment(period.start, "HH:mm:ss").format("HH:mm");
            break;

          }

        }
      }

    }

    return openFlag;


  }

  $_getShippingPrices(id_webshop: any): Observable<any> {

    const params = { id_webshop: id_webshop };

    return from(this.baseClient.postBaseApi("shipping_costs", params)).pipe(
      map(data => data.list)
    )
  }


  async $_getEligibleCities(id_webshop: string): Promise<DeliveryZone[]> {
    const params = { id_webshop: id_webshop };

    try {
      // Utiliser directement la Promise retournée par postBaseApi
      const data = await this.baseClient.postBaseApi("delivery_zones", params);

      // Extraire les villes éligibles de la réponse
      const eligibleCities = data.list.filter((city: any) => city.city !== null);

      // Retourner les villes éligibles en tant que Promise résolue
      return eligibleCities;
    } catch (error) {
      console.error('❌ Erreur lors de l\'obtention des eligible cities:', error);
      throw error; // Propager l'erreur pour qu'elle puisse être gérée ailleurs
    }
  }


  // getPosTerms(userKey?: string, posId?: number,): Observable<any> {
  //   const pointOfSaleId = posId ? posId : this.tools.getStor("point_of_sale").id;
  //   return from(this.base2.getBase("points_of_sale/terms/" + pointOfSaleId, null, userKey))
  //     .pipe(
  //       map(data => {
  //         console.log("data.object : ", data.object)
  //         return data.object;
  //       })
  //     )
  // }

  // Conditions générales du commerçant
  // $_getPosTerms(id_webshop?: any): Observable<any> {
  //   const params = id_webshop ? { id_webshop: id_webshop } : {};
  //   return from(this.baseClient.postBaseApi("points_of_sale/terms", params))
  //     .pipe(
  //       map(data => {
  //         return data.object;
  //       })
  //     )
  // }

  // // Condition générales de Fulle
  // getPosTermsFulle(id_webshop?: any): Observable<any> {
  //   const params = id_webshop ? { id_webshop: id_webshop } : {};
  //   return from(this.baseClient.postBaseApi("points_of_sale/terms/fulle", params))
  //     .pipe(
  //       map(data => {
  //         return data.object;
  //       })
  //     )
  // }

  getDefaultBanner(pointData: any, isArray: boolean = false, userKey: any = null): Promise<any> {
    return new Promise(resolve => {
      return this.getUserAccount(userKey).then(data => {
        const currBanner = (data.object) ? this.banners.filter(banner => banner.activity === data.object.id_activity) : this.banners;
        const parseCurrBanner = "assets/img/banners/" + currBanner[0].banner + ".jpg";
        if (isArray) {
          pointData.map((point: any) => {
            if (!point.banner_original)
              point.banner_original = parseCurrBanner;
          });
        } else {
          if (!pointData.banner_original)
            pointData.banner_original = parseCurrBanner;
        }
        resolve(pointData);
      });
    });
  }


  $_getCloseInDay(pointData: any, isArray: boolean = false, id_merchant = null): Promise<any> {

    return new Promise(resolve => {

      if (isArray && pointData) {
        pointData.map((point: any) => {

          // if (!point.banner_original) {
          //   point.banner_original = parseCurrBanner;
          // }
        });
      } else {
        // if (pointData && !pointData.banner_original) {
        //   pointData.banner_original = parseCurrBanner;
        // }
      }
      resolve(pointData);
    })
  }

  $_getDefaultBanner(pointOfSales: any, isArray: boolean = false, id_merchant = null): Promise<any> {
    return new Promise(resolve => {
      if (isArray && pointOfSales) {
        pointOfSales.map((pointOfSale: any) => {
          if (!pointOfSale.banner_original)
            pointOfSale.banner_original = this.getDefaultBannerSrc(pointOfSale);
        });
      } else {
        if (pointOfSales && !pointOfSales.banner_original)
          pointOfSales.banner_original = this.getDefaultBannerSrc(pointOfSales);
      }
      resolve(pointOfSales);
    });
  }

  getDefaultBannerSrc(pointOfSale: any) {
    const currBanner = this.banners.filter(banner => banner.activity === pointOfSale.id_activity);
    return "assets/img/banners/" + currBanner[0].banner + ".jpg";
  }

  getships(storPOSs: any, storSM: any) {
    return new Promise(resolve => {
      if (storSM.enable_shipping_cost > 0) {
        storPOSs.forEach((element: any) => {
          this.$_getShippingPrices(element.id_webshop).subscribe(data => {
            element.shipping_costs = data;
          });
        });
        resolve(storPOSs);
      } else if (storSM.enable_delivery > 0) {
        storPOSs.forEach((element: any) => {
          this.$_getEligibleCities(element.id_webshop).then(data => {
            element.eligible_zones = data;
          });
          resolve(storPOSs);
        });
      }
    })
  }

  /**
   * Récupération des informations du compte
   * @param user_key
   */
  getUserAccount(user_key?: string): Promise<any> {
    return (user_key) ? this.base2.getBase("account", null, user_key) : this.base2.getBase("account");
  }

  $_getUserAccount(id_merchant?: any): Promise<any> {

    return (id_merchant) ? this.baseClient.postBaseApi("account_merchant", { id_merchant: id_merchant }) : this.baseClient.postBaseApi("account");
  }


  //TODO vérifie rl'uilisation du param "same" ?
  setPoint(point: any, same: boolean = false): void {
    const existingPos = this.tools.getStor("point_of_sale");
    // console.log('pointofsale.service - setPoint - point :', point);
    // console.log('pointofsale.service - setPoint - same :', same);
    // console.log('pointofsale.service - setPoint - existingPos :', existingPos);

    if (!same) {
      this.smApi.setSaleMeth(null, null);
      this.panMan.removePanier();
    } else {
      // Si same=true, préserver les eligible_zones

      if (existingPos?.eligible_zones?.length > 0) {
        point.eligible_zones = existingPos.eligible_zones;
        // console.log('[PointofsaleService] Préservation:', point.eligible_zones.length, 'zones');
      }
    }

    point.timetables = this.sortTimeTable(point.timetables);
    this.tools.setStor("point_of_sale", point);
    this.tools.removeStor("date_order");
    this.tools.removeStor("hour_order");
  }

  sortTimeTable(timetables: any): void {
    if (timetables.length > 0 && timetables[0].day !== 1) {
      timetables.push(timetables.shift())
    }
    return timetables;
  }

  $_getUserKeyByMerchantId(merchantId: string | number) {
    const params = { id_merchant: merchantId };

    return this.baseClient
      .postBaseApi("webshop_meta_merchant", params)
      .then((data: any) => {
        console.log('[getUserKeyByMerchantId] raw data =', data);

        if (!data || typeof data !== 'object') {
          throw new Error('[getUserKeyByMerchantId] API returned non-object payload');
        }

        // ⚠️ adapte ICI à ta vraie structure de réponse
        if (!('object' in data)) {
          throw new Error('[getUserKeyByMerchantId] missing "object" in payload: ' + JSON.stringify(data));
        }

        // if (!data.object) {
        //   throw new Error('[getUserKeyByMerchantId] data.object is null/undefined: ' + JSON.stringify(data));
        // }

        // if (!data.object.id_merchant) {
        //   throw new Error('[getUserKeyByMerchantId] missing id_merchant in data.object: ' + JSON.stringify(data.object));
        // }

        return data;
      });
  }

  $_getUserKeyByWebShopId(webshopId: string | number, prov?: any) {
    // Déja sauvegardé
    if ((this.webshopCurrentMerchant == webshopId) && (this.webshopMetaObject != null)) {
      return new Promise(resolve => {
        resolve(this.webshopMetaObject);
      })
    }
    const params = { id_webshop: webshopId };
    return new Promise(resolve => {
      this.baseClient.postBaseApi("webshop_meta", params).then(meta => {
        // Sauvegarde
        this.webshopMetaObject = meta
        this.webshopCurrentMerchant = webshopId
        this.$_getDefaultBanner(meta.object.point_of_sale).then(parsedPoints => {
          this.webshopMetaObject.object.point_of_sale.banner_original = parsedPoints.banner_original;
          resolve(this.webshopMetaObject);
        });
      });
    });
  }

  getClosingsDaysHorarys() {
    let currPos: any = this.tools.getStor("point_of_sale");
    let currentDate = moment().format("YYYY-MM-DD");
    if (currPos) {
      const params = {
        pos_id: currPos.id,
        date_order: currentDate,
        id_webshop: currPos.id_webshop
      };
      return this.baseClient.postBaseApi("point_of_sale/closings_days_horaries", params);
    }

    return new Promise((resolve) => {
      resolve({ data: { closingHoraries: null } });
    })
  }
}
